import type { SVGProps } from 'react';
import { useId } from 'react';

const MetropolisNetwork = (props: SVGProps<SVGSVGElement>) => {
  const gradientId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect x="0.556" y="0.556" width="38.889" height="38.889" rx="8.333" fill="white" />
      <rect
        x="0.556"
        y="0.556"
        width="38.889"
        height="38.889"
        rx="8.333"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.111"
      />
      <path
        d="M15.568 22.463H12.133C11.939 22.463 11.75 22.524 11.592 22.638C11.435 22.751 11.317 22.911 11.255 23.096L9.4 28.651C9.353 28.79 9.34 28.939 9.362 29.084C9.384 29.229 9.441 29.366 9.526 29.486C9.612 29.605 9.725 29.702 9.855 29.769C9.986 29.836 10.131 29.87 10.277 29.871H26.944C27.091 29.87 27.235 29.835 27.366 29.769C27.496 29.702 27.609 29.605 27.695 29.486C27.78 29.367 27.837 29.229 27.859 29.084C27.881 28.939 27.868 28.791 27.822 28.652L25.97 23.096C25.909 22.912 25.791 22.752 25.633 22.638C25.475 22.524 25.286 22.463 25.091 22.463H21.654M24.166 16.907C24.166 20.253 20.584 23.786 19.173 25.051C19.011 25.174 18.814 25.241 18.611 25.241C18.408 25.241 18.21 25.174 18.049 25.051C16.638 23.786 13.055 20.253 13.055 16.907C13.055 15.434 13.641 14.021 14.682 12.979C15.724 11.937 17.137 11.352 18.611 11.352C20.084 11.352 21.497 11.937 22.539 12.979C23.581 14.021 24.166 15.434 24.166 16.907ZM20.463 16.907C20.463 17.93 19.634 18.759 18.611 18.759C17.588 18.759 16.759 17.93 16.759 16.907C16.759 15.885 17.588 15.056 18.611 15.056C19.634 15.056 20.463 15.885 20.463 16.907Z"
        stroke="currentColor"
        strokeWidth="0.926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="40"
          y1="16.936"
          x2="0"
          y2="16.589"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7749" />
          <stop offset="1" stopColor="#5F59FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default MetropolisNetwork;
